import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * 
 * Resets scroll position to top (0,0) on every route change.
 * Only applies to full-page navigation, not:
 * - Anchor links within the same page (hash changes)
 * - Modal windows
 * - Accordion expansions
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Only scroll to top for full page navigation (pathname changes)
    // Skip if it's just a hash change (anchor link on same page)
    if (!hash) {
      // Use requestAnimationFrame for smooth, flicker-free transition
      requestAnimationFrame(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant' // Use instant for immediate jump without animation
        });
      });
    }
  }, [pathname, hash]);

  return null; // This component doesn't render anything
};

export default ScrollToTop;
